/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_WhereInputs */

const en_us2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where does it hurt most?`)
};

const pt_br2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde dói mais?`)
};

const es_419_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde duele más?`)
};

const pt_pt2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde dói mais?`)
};

const fr_fr2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où as-tu le plus mal ?`)
};

const de_de2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo tut es am meisten weh?`)
};

const it_it2_today_checkin_where = /** @type {(inputs: Today_Checkin_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove fa più male?`)
};

/**
* | output |
* | --- |
* | "Where does it hurt most?" |
*
* @param {Today_Checkin_WhereInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_where = /** @type {((inputs?: Today_Checkin_WhereInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_WhereInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_where(inputs)
	if (locale === "es-419") return es_419_today_checkin_where(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_where(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_where(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_where(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_where(inputs)
	return en_us2_today_checkin_where(inputs)
});
export { today_checkin_where as "today.checkin_where" }